import { TimerCancelOutlineIcon } from './TimerCancelOutlineIcon';

/**
 * author: Colton Wiscombe
 * id F36D3C1A-6148-491D-AED6-B6F1883229BD
 * name timer-cancel-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-cancel-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchCancelOutlineIcon = TimerCancelOutlineIcon;
export default StopwatchCancelOutlineIcon